import SpriteSymbol from "../../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../svg-sprite-loader/runtime/sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "diamond.icon-d5846b",
  "use": "diamond.icon-d5846b-usage",
  "viewBox": "0 0 25 25",
  "content": "<symbol viewBox=\"0 0 25 25\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"diamond.icon-d5846b\">\n<path d=\"M1.00024 9H23.0002\" stroke=\"#262626\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M1.00024 9L5.00024 4H19.0002L23.0002 9L12.0002 22L1.00024 9Z\" stroke=\"#262626\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol